import axios from "axios";

const service = axios.create({
	baseURL: "/api/", // 接口域名的地址
	headers: {
		"Content-Type": "application/json; charset=utf-8",
		lang: "zh-cn",
	},
});

export default function request(url, data = {}, method = "post") {
	return new Promise((resolve, reject) => {
		const options = {
			url,
			method,
		};
		if (method.toLowerCase() === "get") {
			options.params = data;
		} else {
			options.data = data;
		}
		service(options)
			.then((res) => {
				resolve(res);
			})
			.catch((error) => {
				reject(error);
			});
	});
}
